import { Text, View, Image } from "@react-pdf/renderer";
import styles from '../styles/styles';

interface HeaderProps {
  labels: {
    title: string;
    date: string;
    buyer: string;
    seller: string;
    measuredBy: string;
    forest: string;
    certificate: string;
    claims: string;
    note: string;
  };
  data: {
    date: string;
    buyer: string;
    seller: string;
    measuredBy: string;
    forest: string;
    certificateNumber: string;
    claims: string;
    note: string;
  };
  logoSrc?: string | Blob | null;
}

const Header = ({ labels, data, logoSrc }: HeaderProps) => (
  <>
    <View style={styles.headerRow}>
      {/* Left side */}
      <View style={{ flex: 1 }}>
        <Text style={styles.header}>{labels.title}</Text>
        <Text>{labels.date}: {data.date}</Text>
      </View>

      {/* Right side */}
      {logoSrc && (
        <View style={{ flex: 1, alignItems: "flex-end" }}>
          <Image
            src={logoSrc}
            style={{
              width: 140,
              height: 24,
              objectFit: "contain"
            }}
          />
        </View>
      )}
    </View>

    <View style={styles.spacer} />

    <View>
      <View style={styles.row}>
        {/* Left */}
        <View>
          <Text style={styles.label}>{labels.buyer}:</Text>
          <Text>{data.buyer}</Text>
        </View>

        {/* Right */}
        <View style={styles.headerRight}>
          <Text style={styles.label}>{labels.seller}:</Text>
          <Text>{data.seller}</Text>

          <View style={styles.spacer} />

          <Text style={styles.label}>{labels.forest}:</Text>
          <Text>{data.forest}</Text>

          <View style={styles.spacer} />

          <Text style={styles.label}>{labels.certificate}:</Text>
          <Text>{data.certificateNumber}</Text>

          <View style={styles.spacer} />
          
          <Text style={styles.label}>{labels.claims}:</Text>
          <Text>{data.claims}</Text>
        </View>
      </View>

      <View style={styles.spacer} />

      <View style={styles.row}>
        {/* Left */}
        <View>
          <Text style={styles.label}>{labels.note}:</Text>
          <Text>{data.note}</Text>
        </View>

        {/* Right */}
        <View style={styles.headerRight}>
          <Text style={styles.label}>{labels.measuredBy}:</Text>
          <Text>{data.measuredBy}</Text>
        </View>
      </View>
    </View>
  </>
);

export default Header;
